import { ca } from '@cian/analytics';
import { INewBuilding } from '../../types/newBuldings';
import { createNewbuildingProduct } from '../../utils';

interface ITrackCardArgs {
  sc: object;
  position: number;
  developerId: number;
  newbuilding: INewBuilding;
  regionId: number;
}

export function trackTitleCardClick({ newbuilding, developerId, position, regionId, sc }: ITrackCardArgs) {
  return () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'CardBuilder',
      action: 'to_cardJK',
      label: 'title',
      sc,
      products: [
        createNewbuildingProduct({
          id: newbuilding.id,
          isKpn: newbuilding.isKpn,
          isReliable: newbuilding.isReliable,
          name: newbuilding.title,
          regionId,
          position,
          developerId: [developerId],
          extra: { from_object: developerId },
        }),
      ],
    });
  };
}

export function trackApartmentsCardClick({ newbuilding, developerId, position, regionId, sc }: ITrackCardArgs) {
  return () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'CardBuilder',
      action: 'to_listing',
      label: 'click_room',
      sc,
      products: [
        createNewbuildingProduct({
          id: newbuilding.id,
          isKpn: newbuilding.isKpn,
          isReliable: newbuilding.isReliable,
          name: newbuilding.title,
          regionId,
          position,
          developerId: [developerId],
          extra: { from_object: developerId },
        }),
      ],
    });
  };
}

export function trackImageCardClick({ newbuilding, developerId, position, regionId, sc }: ITrackCardArgs) {
  return () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'CardBuilder',
      action: 'to_cardJK',
      label: 'photo',
      sc,
      products: [
        createNewbuildingProduct({
          id: newbuilding.id,
          isKpn: newbuilding.isKpn,
          isReliable: newbuilding.isReliable,
          name: newbuilding.title,
          regionId,
          position,
          developerId: [developerId],
          extra: { from_object: developerId },
        }),
      ],
    });
  };
}

export function trackMoreButtonCardClick({ newbuilding, developerId, position, regionId, sc }: ITrackCardArgs) {
  return () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'CardBuilder',
      action: 'to_cardJK',
      label: 'more_about',
      sc,
      products: [
        createNewbuildingProduct({
          id: newbuilding.id,
          isKpn: newbuilding.isKpn,
          isReliable: newbuilding.isReliable,
          name: newbuilding.title,
          regionId,
          position,
          developerId: [developerId],
          extra: { from_object: developerId },
        }),
      ],
    });
  };
}

export function trackSeeAllButtonCardClick({ newbuilding, developerId, position, regionId, sc }: ITrackCardArgs) {
  return () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'CardBuilder',
      action: 'to_listing',
      label: 'show_all_flats',
      sc,
      products: [
        createNewbuildingProduct({
          id: newbuilding.id,
          isKpn: newbuilding.isKpn,
          isReliable: newbuilding.isReliable,
          name: newbuilding.title,
          regionId,
          position,
          developerId: [developerId],
          extra: { from_object: developerId },
        }),
      ],
    });
  };
}
